import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=d55295f2&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=d55295f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55295f2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductList.vue
// module id = vmgX
// module chunks = 1